<div class="web-allocator maximized">
  <app-patient-crud [allowFormPopulationViaQueryString]="true"></app-patient-crud>
</div>
